(() => {
  const ROOT = '[data-plexigo-personalization]';

  function normalizeInstagram(value) {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (/^https?:\/\//i.test(raw)) return raw;
    const username = raw.replace(/^@+/, '').replace(/^instagram\.com\//i, '').replace(/^www\.instagram\.com\//i, '').split(/[/?#]/)[0];
    return username ? `https://instagram.com/${username}` : raw;
  }

  function formatIban(value) {
    const compact = String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    return compact.replace(/(.{4})/g, '$1 ').trim();
  }

  function setError(card, message) {
    const error = card?.querySelector('[data-plexigo-field-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
    card.classList.toggle('has-error', Boolean(message));
  }

  function validateInput(input) {
    const card = input.closest('[data-plexigo-field-card]');
    if (input.type === 'file') {
      const file = input.files?.[0];
      if (!file) {
        setError(card, input.hasAttribute('data-plexigo-bank-qr') ? 'Banka QR görselini yükleyin.' : 'Logo dosyanızı yükleyin.');
        return false;
      }
      const max = Number(input.dataset.maxSize || 0);
      if (max && file.size > max) {
        setError(card, 'Dosya boyutu 10 MB’dan küçük olmalıdır.');
        return false;
      }
      setError(card, '');
      return true;
    }

    let value = String(input.value || '').trim();
    if (input.hasAttribute('data-plexigo-instagram')) {
      value = normalizeInstagram(value);
      input.value = value;
    }
    if (input.hasAttribute('data-plexigo-iban')) {
      value = formatIban(value);
      input.value = value;
    }
    if (!value) {
      const label = input.closest('label')?.querySelector('span')?.textContent?.trim() || 'Bu alan';
      setError(card, `${label} zorunludur.`);
      return false;
    }
    setError(card, '');
    return true;
  }

  function init(root) {
    if (!root || root.dataset.plexigoPersonalizationReady === 'true') return;
    root.dataset.plexigoPersonalizationReady = 'true';
    const form = root.closest('form');
    if (!form) return;

    root.querySelectorAll('input[type="file"]').forEach((input) => {
      input.addEventListener('change', () => {
        const nameEl = input.closest('.plexigo-upload-field')?.querySelector('[data-plexigo-file-name]');
        const file = input.files?.[0];
        if (nameEl) nameEl.textContent = file ? file.name : 'Dosya seçilmedi';
        if (file) validateInput(input);
      });
    });

    root.querySelectorAll('[data-plexigo-instagram]').forEach((input) => {
      input.addEventListener('blur', () => {
        if (input.value.trim()) input.value = normalizeInstagram(input.value);
      });
    });

    root.querySelectorAll('[data-plexigo-iban]').forEach((input) => {
      input.addEventListener('input', () => {
        const cursorAtEnd = input.selectionStart === input.value.length;
        input.value = formatIban(input.value);
        if (cursorAtEnd) input.setSelectionRange(input.value.length, input.value.length);
      });
    });

    form.addEventListener('submit', (event) => {
      const required = [...root.querySelectorAll('[data-plexigo-required]')];
      let firstInvalid = null;
      for (const input of required) {
        if (!validateInput(input) && !firstInvalid) firstInvalid = input;
      }
      if (!firstInvalid) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const card = firstInvalid.closest('[data-plexigo-field-card]');
      card?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => firstInvalid.focus?.(), 350);
    }, true);
  }

  function initAll(scope = document) {
    scope.querySelectorAll?.(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.(ROOT)) init(node);
        initAll(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
